import {createContext, useContext} from 'react';
import {HasHorizontalOffset, HasVerticalOffset} from '../types';

export type LayoutOffset = HasHorizontalOffset & HasVerticalOffset;

export const LayoutOffsetContext = createContext<LayoutOffset>({horizontalOffset: 0, verticalOffset: 0});

export function useLayoutOffset(): LayoutOffset {
  return useContext(LayoutOffsetContext);
}
